import React, { useState, useEffect } from "react";
import "./HistoryTab.scss";
import Search from "../../images/search.svg";
import BatchTable from "../BatchTable/BatchTable";
import { ScheduleJobList2, ScheduleJobList3 } from "../../util/API/batch";
import { useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, CircularProgress } from "@mui/material";

function HistoryTab() {
  const [searchText, setSearchText] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false); 

  //User from the Redux store
  const merchantInfo = useSelector((state) => state.login.user);

  const getHistoryList = async () => {
    const historyList = await ScheduleJobList3("");

    if (historyList.callStatus == 1) {
      if (historyList.payload.record.length) {
        setHistory(historyList.payload.record);
      } else {
        setHistory([historyList.payload.record]);
      }
    }
  };

  //Get the history of the batch
  useEffect(() => {
    getHistoryList();
  }, []);

  //Get the history of the batch with the number of rows
  const getHistoryListParams = async (rows) => {
    try {
      setLoading(true)
      const historyList = await ScheduleJobList3(rows);

      if (historyList.callStatus == 1) {
        if (historyList.payload.record.length) {
          setHistory(historyList.payload.record);
        } else {
          setHistory([historyList.payload.record]);
        }
      }
    } catch (error) {
      console.log("error================",error);
    } finally {
      setLoading(false)

    }
    
  };

  //Refresh the history of the batch
  const refreshHistoryList = async () => {
  setLoading(true);  
  try {
    const historyList = await ScheduleJobList3(merchantInfo.id);

    if (historyList.callStatus == 1) {
      if (historyList.payload.record.length) {
        setHistory(historyList.payload.record);
      } else {
        setHistory([historyList.payload.record]);
      }
    }
  } catch (error) {
    console.log("error================", error);
  } finally {
    setLoading(false);  // Stop loader regardless of success/failure
  }
};

  const setNewHistory = (records) => {
    setHistory(records);
  };

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setSearchText(inputText);
    // handleSearch(inputText);
  };

  const filteredHistory = history.filter((row) => {
    const searchValue = searchText.trim().toLowerCase();

    if (!searchValue) {
      return true;
    }

    const requestDate = row?.Scheduleinstance?.requesttime?.toString().toLowerCase() || "";

    const scheduledDate = row?.Scheduleinstance?.scheduletime?.toString().toLowerCase() || "";

    return (
      requestDate.includes(searchValue) ||
      scheduledDate.includes(searchValue)
    );
  });
  
  return (
    <div className="history-container">
      <div className="history-header">
        <div className="history-left">
          <div className="filter-records-text">Filter Records:</div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(30)}
          >
            30
          </div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(60)}
          >
            60
          </div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(100)}
          >
            100
          </div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(200)}
          >
            200
          </div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(500)}
          >
            500
          </div>
          <div
            className="filter-button"
            onClick={() => getHistoryListParams(1000)}
          >
            1000
          </div>
        </div>

        <div className="history-right">
          <label for="search">Search By</label>

          <div className="search-container-batch">
            <input
              placeholder="Date (yyyy-mm-dd)"
              value={searchText}
              name="search"
              onChange={handleInputChange}
            />
            <img src={Search} alt="Search Icon" />
          </div>
          <div className="pointer" onClick={refreshHistoryList}>
            <RefreshIcon />
          </div>
        </div>
      </div>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <CircularProgress />
        </Box>
      ) : filteredHistory.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "150px",
            color: "#6b7280",
            fontSize: "16px",
          }}
        >
          {searchText.trim()
            ? `No records found for "${searchText.trim()}".`
            : "No history records available."}
        </Box>
      ) : (
        <div>
          <BatchTable
            history={filteredHistory}
            setNewHistory={setNewHistory}
            refreshHistoryList={refreshHistoryList}
            getHistoryList={getHistoryList}
          />
        </div>
      )}
    </div>
  );
}

export default HistoryTab;
